export default "__VITE_ASSET__D76Z95P8__"